module.exports = __webpack_public_path__ + "img/logo_pc.48b14714.svg";